/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2019 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import React from 'react';

import { defineMessages } from '@nebula/izzy/intl';

import { Form, FormField } from '@nebula/luna/dist/core/form';

const MSG = defineMessages({
  baseURL: {
    id: 'gemini.session.baseURL',
    defaultMessage: 'Base URL'
  },
  name: {
    id: 'gemini.session.name',
    defaultMessage: 'Session Name'
  },
  invalidURL: {
    id: 'gemini.session.baseURL.invalid',
    defaultMessage: 'Invalid URI'
  },
  required: {
    id: 'gemini.session.create.error.required',
    defaultMessage: 'Missing {fieldName}'
  }
});

const SessionFormContent = ({
  sessionForm,
  izzy,
  nameField,
  urlField,
  ...props
}) => (
  <React.Fragment>
    <Form
      onSubmit={sessionForm.onSubmit}
      {...props}
    >
      <FormField
        id="createSessionFormName"
        errorMessages={{
          'error.required': izzy(MSG.required, { fieldName: izzy(MSG.name) })
        }}
        field={nameField}
        fieldProps={{
          quiet: true
        }}
        label={izzy(MSG.name)}
        labelPosition="top"
      />
      <FormField
        id="createSessionFormURL"
        errorMessages={{
          'error.required': izzy(MSG.required, { fieldName: izzy(MSG.baseURL) }),
          'error.string.regex': izzy(MSG.invalidURL)
        }}
        field={urlField}
        fieldProps={{
          quiet: true
        }}
        label={izzy(MSG.baseURL)}
        labelPosition="top"
      />
    </Form>
  </React.Fragment>
);

SessionFormContent.displayName = 'SessionFormContent';
export default SessionFormContent;
